import React from 'react';
import styled from 'styled-components/macro';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Typography, mediaQuery } from '@deeptrue-frontend/ui';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import env from 'consts/env';

const LeftSideContainer = styled.div`
  display: none;
  padding: 5rem 10rem 5rem 5.8rem;
  margin-top: 3.9rem;
  color: white;
  max-width: 60rem;

  ${mediaQuery.md`
    display: block;
    padding: 5rem;
  `};

  ${mediaQuery.lg`
    padding: 5rem 10rem 5rem 5.8rem;
  `};
`;

const WhiteLogo = styled(Logo)`
  width: 158px;
`;

interface SidePageProps {
  children: React.ReactNode;
  splashImage: string;
  title: string;
  slogan?: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
  },
  image: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: '1.5rem 2rem 1.5rem 1.5rem',
    display: 'flex',
    minHeight: 'calc(100vh - 3rem)',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      margin: '3rem',
      minHeight: 'calc(100vh - 6rem)',
    },
    [theme.breakpoints.up('lg')]: {
      margin: '2rem 5rem 2rem 7rem',
    },
  },
  logo: {
    color: '#1F5DEA',
    maxWidth: '60%',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

export const SidePage = ({
  splashImage,
  children,
  title,
  slogan,
}: SidePageProps) => {
  const classes = useStyles();
  const logoUrl = env.IS_PRODUCTION
    ? 'https://deeptrue.com/'
    : 'https://dev.deeptrue.com/';

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        lg={7}
        className={classes.image}
        style={{
          backgroundImage: `url(${splashImage})`,
          backgroundColor: 'rgb(29,78,178)',
        }}
      >
        <LeftSideContainer>
          <a
            href={logoUrl}
            style={{
              color: 'inherit',
              textDecoration: 'inherit',
            }}
          >
            <WhiteLogo />
          </a>
          {slogan}
        </LeftSideContainer>
      </Grid>
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        lg={5}
        component={Paper}
        elevation={6}
        square
      >
        <div className={classes.paper}>
          <Grid container>
            <Grid item xs className={classes.logo}>
              <Logo />
            </Grid>
          </Grid>
          <Typography
            variant="h4"
            textAlign="left"
            mt="2rem"
            alignSelf="start"
            color="royalBlue"
          >
            {title}
          </Typography>
          {children}
        </div>
      </Grid>
    </Grid>
  );
};

export default SidePage;
